import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Spinner, Card, Row, Col, Badge, Button } from 'react-bootstrap';
import ENDPOINT from '../../data/ENDPOINT';
import { AuthContext } from '../../context/AuthContext';
import DeleteIcon from '@mui/icons-material/Delete';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Snackbar from "@mui/material/Snackbar";

const CartManager = () => {
  const [cartItems, setCartItems] = useState([]);
  const [toolDetails, setToolDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('')
  const { user, setCartCount } = useContext(AuthContext);
    const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const fetchCartAndTools = async () => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append('session', user.SessionId);

      const response = await axios.post(`${ENDPOINT}get_cart_and_tool.php`, formData);

      if (response.data.status === 'success') {
        const { cart_items, tool_details } = response.data.data;

        setCartItems(cart_items);
        if (Array.isArray(cart_items) && cart_items.length === 0) setCartCount(0);

        // Convert tool_details array to dictionary for easier access
        const toolMap = {};
        tool_details.forEach(tool => {
          toolMap[tool.tool_id] = tool;
        });
        setToolDetails(toolMap);

      } else {
        setError(response.data.message || 'Unknown error occurred');
      }
    } catch (err) {
      setError('Failed to fetch cart data');
    } finally {
      setLoading(false);
    }
  };

  // Remove cart item handler
  const handleRemove = async (cart_id) => {
    if (!user.SessionId) return;
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('session', user.SessionId);
      formData.append('tool_id', cart_id);

      const response = await axios.post(`${ENDPOINT}delete_cart_item.php`, formData);

      if (response.data.status === 'success') {
    fetchCartAndTools()
    setOpen(true)
    setMessage('Item Deleted Succfully')
      } else {
        setError(response.data.message || 'Failed to remove item');
        setOpen(true)
    setMessage('Failed to remove item')
      }
    } catch (err) {
      setError('Failed to remove item');
    } finally {
      setLoading(false);       

    }
  };

  useEffect(() => {
    if (user.SessionId) {
      fetchCartAndTools(user.SessionId);
    }
    // eslint-disable-next-line
  }, [user.SessionId]);

  if (loading) {
    return <div className="text-center my-4"><Spinner animation="border" /></div>;
  }

  return (
    <div className="container mt-4 min-vh-70 ">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="mb-0">
          <ShoppingCartIcon className="me-2 text-success" fontSize="large" />
          My Cart
        </h2>
        <span className="badge bg-success fs-6">{cartItems.length} Items</span>
      </div>

      {error && <div className="alert alert-danger mb-3">{error}</div>}

      {cartItems.length > 0 ? (
        <Row xs={1} md={2} lg={3} className="g-4 py-3 ">
          {cartItems.map((item) => {
            const tool = toolDetails[item.sell_tool_id];
            return (
              <Col key={item.sell_cart_id}>
                <Card className="shadow h-100 border-0 rounded-4 position-relative cart-card-hover">
                  <Button
                    variant="light"
                    className="position-absolute"
                    style={{ top: 10, right: 10, zIndex: 2 }}
                    onClick={() => handleRemove(item.sell_cart_id)}
                    title="Remove from cart"
                  >
                    <DeleteIcon style={{ color: "#dc3545" }} />
                  </Button>
                  {/* Tool Image */}
                  {tool && tool.tool_image && (
                    <Card.Img
                      variant="top"
                      src={tool.tool_image}
                      alt={tool.tool_name}
                      style={{
                        height: 180,
                        objectFit: "cover",
                        borderTopLeftRadius: "1rem",
                        borderTopRightRadius: "1rem",
                        background: "#f8f9fa"
                      }}
                    />
                  )}
                  <Card.Body>
                  
                    <h5 className="mb-2 text-success fw-bold">{tool ? tool.tool_name : 'Loading...'}</h5>
                    <div className="mb-2">
                      <span className="fw-semibold">Price:</span>{' '}
                      {tool ? (
                        <span className="text-danger fw-bold">
                          <strike>₹{parseFloat(tool.tool_price).toFixed(2)}</strike>{' '}
                          ₹{(parseFloat(tool.tool_price) * 0.8).toFixed(2)}
                        </span>
                      ) : (
                        'Loading...'
                      )}
                    </div>
                    <Button className='w-100 mt-3' variant="success">
                      Buy Tool
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="text-center col-12 h-100   ">
          <div className='my-auto' >
            <ShoppingCartIcon style={{ fontSize: 60, color: "#e0e0e0" }} />
          <h4 className="mt-3 text-secondary">No cart items found.</h4>
          <Button className=' mt-3' variant="success">
         <Link to='/hardware-tools' className="text-decoration-none" >
            Go back to tools</Link>
          </Button>
          </div>
        </div>
        
      )}



      <style>{`
        .cart-card-hover {
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .cart-card-hover:hover {
          box-shadow: 0 8px 32px #0002 !important;
          transform: translateY(-2px) scale(1.01);
        }
      `}</style>

        <Snackbar
      
              open={open}
              autoHideDuration={5000}
              onClose={handleClose}
              message={message}
            />
    </div>
  );
};

export default CartManager;
